export default [
  'en_BD',
  'en_BH',
  'en_BN',
  'en_HK',
  'en_ID',
  'en_IL',
  'en_IQ',
  'en_JO',
  'en_KH',
  'en_KW',
  'en_LA',
  'en_LB',
  'en_LK',
  'en_MN',
  'en_MV',
  'en_MY',
  'en_NP',
  'en_OM',
  'en_PH',
  'en_PK',
  'en_PS',
  'en_QA',
  'en_SA',
  'en_SG',
  'en_TH',
  'en_TW',
  'en_VN',
  'en_YE'
];
